import { useFormatDate } from "@shared/hooks/useFormatDate";
import { getProfileImage } from "@shared/hooks/useProfile";
import theme from "@shared/utils/themeColors";
import { useEffect } from "react";
import { Link } from "react-router-dom";
import { useCommunityStore } from "../../store/communityStore";

export function FeedRightContent() {
  const { getRandomUsers, getTrendingPosts, randomUsers, trendingPosts } =
    useCommunityStore();
  const { formatRelativeTime } = useFormatDate();

  useEffect(() => {
    const state = useCommunityStore.getState();
    const shouldForceRandomUsers = state.randomUsers.length === 0;
    const shouldForceTrendingPosts = state.trendingPosts.length === 0;

    getRandomUsers(4, shouldForceRandomUsers);
    getTrendingPosts(5, shouldForceTrendingPosts);
  }, [getRandomUsers, getTrendingPosts]);
  return (
    <div className="w-full hidden xl:block xl:w-72">
      <div className="lg:sticky lg:top-16 lg:h-[calc(100dvh-64px)] lg:overflow-x-hidden lg:overflow-y-auto no-scrollbar">
        <div className="md:py-8">
          {/* Blocks */}
          <div className="space-y-4">
            {/* Block 2 */}
            <div className={`${theme.bg.primary} p-4 rounded-xl`}>
              <div
                className={`text-xs font-semibold text-gray-400 dark: ${theme.text.muted}`}
              >
                Who to follow
              </div>
              <ul className="space-y-3">
                {randomUsers.map((user) => (
                  <li key={user.id}>
                    <div className="flex items-center justify-between">
                      <div className="grow flex items-center">
                        <div className="relative mr-3">
                          <img
                            className="w-8 h-8 rounded-full"
                            src={getProfileImage(user.profile)}
                            width="32"
                            height="32"
                            alt={user.profile.name}
                          />
                        </div>
                        <div className="truncate">
                          <Link
                            to={`/community/profile/${user.id}`}
                            className={`text-sm font-medium ${theme.text.primary} hover:text-violet-500 dark:hover:text-violet-400`}
                          >
                            {user.profile.name}
                          </Link>
                        </div>
                      </div>
                      <Link
                        to={`/community/profile/${user.id}`}
                        className={`btn-xs text-xs ${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300 px-2.5 Link rounded-full shadow-none`}
                      >
                        View
                      </Link>
                    </div>
                  </li>
                ))}
              </ul>
              <div className="mt-4">
                <Link
                  to="/community/members"
                  className={`btn-sm w-full ${theme.bg.primary} ${theme.border.primary} hover:border-gray-300 dark:hover:border-gray-600 text-gray-800 dark:text-gray-300 text-center`}
                >
                  View All
                </Link>
              </div>
            </div>

            {/* Block 3 */}
            <div className={`${theme.bg.primary} p-4 rounded-xl`}>
              <div
                className={`text-xs font-semibold text-gray-400 dark: ${theme.text.muted}`}
              >
                Trends for you
              </div>
              <ul className="space-y-3">
                {trendingPosts.map((post) => (
                  <li key={post.id}>
                    <div className="text-sm mb-1">
                      <Link
                        to={`/community/post/${post.id}`}
                        className="font-medium text-gray-800 hover:text-gray-900 dark:text-gray-100 dark:hover:text-white"
                      >
                        {post.content}
                      </Link>
                    </div>
                    <div className={`text-xs ${theme.text.muted}`}>
                      <span>{post.comments} comments</span>
                      <span>•</span>
                      <span>{post.likes} likes</span>
                    </div>
                  </li>
                ))}
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
